<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Blend', apiMethod: 'Blends', form: () => import('../forms/BlendForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Blend Component', apiMethod: 'BlendComponents', parentForeignKey: 'blendId', form: () => import('../forms/BlendComponentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Blend Honey Type', apiMethod: 'BlendHoneyTypes', parentForeignKey: 'blendId', form: () => import('../forms/BlendHoneyTypeForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Blend Receival', apiMethod: 'BlendReceivals', parentForeignKey: 'blendId', form: () => import('../forms/BlendReceivalForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Components', value: 'blendId', isCard: true, table: () => import('../tables/BlendComponentsTable') },
                    { text: 'Honey Types', value: 'blendId', isCard: true, table: () => import('../tables/BlendHoneyTypesTable') },
                    { text: 'Receivals', value: 'blendId', isCard: true, table: () => import('../tables/BlendReceivalsTable') },
                    { text: 'Products', value: 'blendId', table: () => import('../tables/ProductsTable') },
                ],
                mainForm: () => import('../forms/BlendForm'),
                claimName: 'Blends',
                apiMethod: 'Blends',
            }
        }
    };
</script>
